import Layout from '@/layout'

const route = {
  path: '/check',
  component: Layout,
  redirect: '/check/index',
  alwaysShow: true, // will always show the root menu
  name: 'check',
  meta: {
    title: 'check',
    icon: 'el-icon-set-up',
    roles: [
      'larke-admin.check.index'
    ]
  },
  sort: 110070,
  children: [
    // 扩展管理
    {
      path: '/check/index',
      component: () => import('@/views/check/index'),
      name: 'checkIndex',
      meta: {
        title: 'checkIndex',
        icon: 'el-icon-tickets',
        roles: [
          'larke-admin.check.index'
        ]
      }
    }
  ]
}

export default route
